import React from 'react'
import './index.css'

/**
 * 包装button组件
 * @param {*} props
 * @returns
 */
export default function LinkButton(props) {
  return <button {...props} className="link-button"></button>
}
